<template>
  <PublicPopup
    ref="DepositoPayPopupRef"
    type="fullScreen"
    position="bottom"
    close-on-click-overlay
    :closeable="false"
    height="100vh"
  >
    <template #content>
      <div class="deposito-pay-popup">
        <van-nav-bar title="Depósito" left-arrow @click-left="close"></van-nav-bar>

        <div class="bodyer-container">
          <div class="order-container info">
            <div class="order-num-box chxy-row-bt">
              <span class="value">{{ filterQcdoeNumShow(payInfoNew.qcdoeNum) }}</span>
              <span class="copy-icon-box" @click="clickCopyPublic(payInfoNew.qcdoeNum)">
                <img
                  class="pay-copy"
                  :src="getImageUrlWithCDN_LOCAL('/public/copy_default_white.svg')"
                />
              </span>
            </div>

            <div class="pay-num-box chxy-row-bt">
              <span class="label">Valor</span>
              <span class="pay-num">{{ filterAmount(props.payInfo.amount) || '0.00' }}</span>
            </div>
          </div>

          <div class="order-container main">
            <div class="prompt-container">
              <p>
                Abra o app com sua chave PIX cadastrada, escolha Pagar com Pix e escaneie o QR Code
                ou copie e cole o código.
              </p>
              <p>
                Este código QR só pode ser pago uma vez, se você precisar pagar novamente, solicite
                novamente
              </p>
            </div>

            <!-- qcdoeNum 替换为新的 qcdoeNum -->
            <div class="qr-code-container chxy-row-c-c">
              <QRCode :value="payInfoNew.qcdoeNum" :size="300" />
            </div>

            <div
              class="copiar-button __button_primary"
              @click="clickCopyPublic(payInfoNew.qcdoeNum)"
            >
              Copiar Código QR
            </div>
          </div>
        </div>

        <div class="pix-icon-box chxy-row-c-c">
          <img class="pix-icon" :src="getImageUrlWithCDN_LOCAL('/deposito/pix_logo_img.webp')" />
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
import QRCode from 'qrcode.vue'
import { STORAGE_USER_INFO_KEY } from '@/stores/mutation-type'
import { rechargeQueryOrderInfoApi } from '@/api/deposito'
const router = useRouter()
const { t } = useI18n()

const props = defineProps({
  payInfo: {
    type: Object,
    default: () => ({}),
  },
})

const DepositoPayPopupRef = ref(null)
const open = () => {
  nextTick(() => {
    console.log('props.payInfo:', props.payInfo)

    payInfoNew.value = props.payInfo
    DepositoPayPopupRef.value.open()
  })
}
const close = () => {
  nextTick(() => {
    DepositoPayPopupRef.value.close()
  })
  handleCloseEmit()
}
const handleCloseEmit = () => {
  emit('close')
}

const time = ref(30 * 60 * 1000)
const payInfoNew = ref({})

const clickCopyAmount = async () => {
  try {
    const text = 'R$' + payInfoNew.value.amount || 0
    await navigator.clipboard.writeText(text)
    showToast('Copiado com sucesso')
  } catch (error) {
    console.log('error ----- ', error)
  }
}

const clickCopyPublic = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    showToast('Copiado com sucesso')
  } catch (error) {
    console.log('error ----- ', error)
  }
}

// 充值金额过滤
const filterAmount = (amount) => {
  // 分转元
  const newAmount = amount / 100
  return newAmount.toFixed(2)
}

const changeTime = (event) => {
  console.log('changeTime...')
}

//
const filterCreateTimeLShow = (value) => {
  // time 时间戳 显示成 日/月/年 时分秒
  if (!value) return ''

  // 如果是时间戳，转换为毫秒
  let timestamp = value
  if (typeof value === 'string' && /^\d+$/.test(value)) {
    // 判断是秒还是毫秒
    timestamp = value.length === 10 ? parseInt(value) * 1000 : parseInt(value)
  } else if (typeof value === 'number') {
    // 判断是秒还是毫秒
    timestamp = value.toString().length === 10 ? value * 1000 : value
  }

  const date = new Date(timestamp)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
}
const filterQcdoeNumShow = (value) => {
  const length = 40
  if (value && value.length > length) {
    // 切割当前字符串的最后length位数
    return '**' + value.substring(value.length - length, value.length - 1)
  }
  return '*******'
}

// 刷新充值状态
watch(
  () => props.payInfo.status,
  (val) => {
    console.log('watch val ----- ', val)
    if (val) {
      playStatus.value = val
    }
  }
)

const status = reactive({
  '00': 'Processando', // 支付中
  90: 'Pendente', // 待扣款
  99: 'Pendente Envio', // 待提交
  '06': 'Pendente Confirmação', // 待确认
  '01': 'Sucesso', // 成功
  '02': 'Falha', // 失败
  '04': 'Estorno', // 退款
  '05': 'Recusado', // 驳回
})
const playStatus = ref('00')
const statusText = computed(() => {
  return status[playStatus.value]
})
const playStatusLoadding = ref(false)
const refreshPlayStatus = async () => {
  playStatusLoadding.value = true
  try {
    const res = await rechargeQueryOrderInfoApi({
      order_no: props.payInfo.merchantOrderId,
    })
    if (res.code == 1) {
      playStatus.value = res.data.status
    }
  } catch (error) {
    // console.log('error ----- ', error)
  } finally {
    playStatusLoadding.value = false
  }
}

const emit = defineEmits(['close'])

defineExpose({
  open,
  close,
})
</script>

<style lang="less" scoped>
.deposito-pay-popup {
  background-color: var(--deposito-pay-view-bg);
  height: 100vh;
  width: 100vw;
  overflow-y: scroll;

  .bodyer-container {
    padding: 10px;

    .order-container + .order-container {
      margin-top: 10px;
    }
    .order-container {
      padding: 10px;
      background-color: var(--deposito-pay-card-bg);
      border: 1px solid var(--deposito-pay-card-border);
      border-radius: 6px;

      &.info {
        .order-num-box {
          text-align: right;

          .value {
            font-size: 14px;
            color: var(--deposito-pay-card-order-id);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
          }
          .pay-copy {
            width: 15px;
            min-width: 15px;
            height: 16px;
            margin-left: 5px;
          }
        }
        .pay-num-box {
          margin-top: 10px;
          padding-top: 20px;
          border-top: 1px solid var(--deposito-pay-card-divider);

          .label {
            font-size: 14px;
            color: var(--deposito-pay-card-label);
          }
          .pay-num {
            font-size: 18px;
            font-weight: 700;
            color: var(--deposito-pay-card-amount);
          }
        }
      }

      &.main {
        padding-bottom: 20px;

        .prompt-container {
          font-size: 14px;
          font-weight: 700;
          color: var(--deposito-pay-card-value);
          text-align: center;

          p {
            text-indent: 20px;
          }
        }

        .qr-code-container {
          margin: 20px auto 40px;
          padding: 10px;
          width: calc(100% - 28px);
          background: var(--deposito-pay-qr-bg);
        }

        .copiar-button {
          margin: 0 auto;
          width: calc(100% - 28px);
        }
      }
    }
  }

  .pix-icon-box {
    margin: 20px auto 40px;
    height: 90px;

    .pix-icon {
      width: 264px;
    }
  }
}
</style>
